export default function ExAddedDate({ addedTime, addedBy }) {
  return (
    <>
      <div className="pjcon-added-at"  style={{color: "#365561", marginRight: "10px"}}>
        <i className="fa-regular fa-calendar-plus"/> {'Added by ' + addedBy + ': '}
        <input
          type="datetime-local"
          className="prjdetails-date-without-icon"
          value={new Date(addedTime).toISOString().slice(0, 16)}
          readOnly
        />
      </div>
    </>
  );
}
